import { simpleAction } from 'src/ducks/utils';

import { ADD_OVERLAY, DELETE_OVERLAY, OverlayAction, Overlay } from './types';

export const pushOverlay = ({ type, props = {} }: Overlay): OverlayAction =>
  simpleAction(ADD_OVERLAY, { type, props });

export const removeOverlay = (overlayId: string | null): OverlayAction =>
  simpleAction(DELETE_OVERLAY, { overlayId });
